import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RegistrationRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Always start with country/language selection as the first step
        navigate('/country-language-selection', { replace: true });
    }, [navigate]);

    // Show loading state while redirecting
    return (
        <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center">
            <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
                <p className="text-accent-600">Redirecting...</p>
            </div>
        </div>
    );
};

export default RegistrationRedirect; 